<template>
    <div id="Header" @click="gotoRoute('PetProfile')">
      <p class="version-number">{{version_number}}</p>
      <p class="version-number beta">Beta</p>
      <img src="@/assets/logo-theme.svg" class="barkbadge-logo" />
    </div>
</template>
<script>
// import {fb, db} from '@/_firebase/init'
import {mapState} from 'vuex'
// import axios from 'axios'
// import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

export default{
  // components:{
  //   'vue-spinner': ClipLoader
  // },
  data(){
    return{
      processing: false,
      showSideMenu: false,
      isAuthenthicated: false,
      sideBarStyle:{
        color: '#000',
        backgroundColor: 'var(--bg-default)'
      },
      imgBrightness:{
        filter: 'brightness(1)'
      },
      placeholder_icon: require('@/assets/icons/question.svg'),
      notification_count: 0,
      userdata:{
        photo:'https://picsum.photos/id/19/200/200',
        fname: 'My',
        lname: 'Name',
        profile_stats:{
          subscribers: 0
        }

      }
    }
  },
  methods:{
    logout(){
      // this.processing = true
      localStorage.removeItem('loggedIn')
      // localStorage.removeItem('uid')
      setTimeout(() => {
        // this.processing = false
        this.$router.push({name: 'GateAuth'})
        location.reload()
      }, 500);
    },
    gotoRoute(route){
      if(route == 'Account'){
        this.displaySideMenu(true)
      }else{
        this.$router.push({name: route})
        this.displaySideMenu(false)
      }
    },
    displaySideMenu(bool){
      this.showSideMenu = bool
    },
    togggleTheme(){
      if(this.theme == 'light'){
        this.sideBarStyle = {
          color: '#fff',
          backgroundColor: '#111'
        }
        this.imgBrightness = {
          filter: 'invert(1)'
        }
        this.SET_THEME('dark')
      }else{
        this.SET_THEME('light')
      }
    },
    // ...mapMutations([
    //   'SET_THEME'
    // ]),
  },
  computed:{
    // ...mapGetters(['isAuthenthicated']),
    ...mapState(['version_number']),
  },
  created(){
    if(localStorage.getItem('loggedIn')){
      this.isAuthenthicated = true
    }
    // this.getNotificationsByType()
    // this.getData()
    // console.log(this.userID)
  }
}
</script>
<style scoped>
#Header{
  position: relative;
  background: #fff;
  width:100%;
  height: 2.4rem;
  z-index: 3;
  position: relative;
  /* border:2px solid #444; */
  border-radius: 0 0 22px 22px ;
  -webkit-box-shadow: 0px 10px 35px -19px rgba(0,0,0,0.75);
  -moz-box-shadow: 0px 10px 35px -19px rgba(0,0,0,0.75);
  box-shadow: 0px 10px 35px -19px rgba(0,0,0,0.75);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor:pointer;
  padding: 1rem 0;
}
.barkbadge-logo{width: 4rem;}
.version-number{
  color: #b6c0f2;
  font-size: .8rem;
  position: absolute;
  top:1rem; left:2rem;
  font-style: italic;
}
.beta{
  top:2rem;
}
body[data-theme='dark']  .petsproject-top-banner{
  background-color: #111;
}
</style>
